import { useClinic } from './useClinic';

const CONSULTORIO = {
  singular: 'Consultório',
  plural: 'Consultórios',
  addLabel: 'Adicionar Consultório',
  newTitle: 'Novo Consultório',
  editTitle: 'Editar Consultório',
  allOption: 'Todos Consultórios',
  emptyMessage: 'Nenhum consultório cadastrado',
  savedMessage: 'Consultório salvo com sucesso.',
  deletedMessage: 'Consultório excluído com sucesso.',
  deleteConfirm:
    'Você tem certeza que deseja excluir este consultório? Essa ação não pode ser desfeita.',
  saveErrorMessage: 'Erro ao salvar consultório.',
  deleteErrorMessage: 'Erro ao excluir consultório.',
};

const SALA = {
  singular: 'Sala',
  plural: 'Salas',
  addLabel: 'Adicionar Sala',
  newTitle: 'Nova Sala',
  editTitle: 'Editar Sala',
  allOption: 'Todas Salas',
  emptyMessage: 'Nenhuma sala cadastrada',
  savedMessage: 'Sala salva com sucesso.',
  deletedMessage: 'Sala excluída com sucesso.',
  deleteConfirm: 'Você tem certeza que deseja excluir esta sala? Essa ação não pode ser desfeita.',
  saveErrorMessage: 'Erro ao salvar sala.',
  deleteErrorMessage: 'Erro ao excluir sala.',
};

// "Consultório" para odontologia; "Sala" apenas quando a clínica é exclusivamente de estética.
// Com os dois módulos (ou nenhum), mantém "Consultório" (o SIGO é dental-first).
export function useRoomLabel() {
  const { clinic } = useClinic();
  const modules = clinic?.modules ?? [];
  const isAestheticOnly = modules.includes('AESTHETIC') && !modules.includes('ODONTO');
  return isAestheticOnly ? SALA : CONSULTORIO;
}
